<template>
  <section>
    <base-card>
      <h2>{{ fullName }}</h2></base-card>
    <base-card>
      <h3>{{ selectedCoach.hourlyRate }}$ per hour</h3></base-card>
  </section>

  <section>
    <base-card>
      <header>
        <h2>Interested? Reach Out Now!</h2>
        <base-button link :to="contactLink">Contact</base-button>
      </header>
      <router-view></router-view>
      <!-- <router-view></router-view> -->
      <!-- router-view za nested child route -->
    </base-card>
  </section>

  <section>
    <base-card>
      <base-badge
        v-for="area in selectedCoach.areas"
        :key="area"
        :type="area"
        :title="area"
      ></base-badge>
      <p>{{selectedCoach.description }}</p>
    </base-card>
  </section>
</template>

<script>
export default {
  // ne rabimo nobenih propsov ker je že CHILD komponenta (poglej vue router)
  // v vue router moramo napisati props:true če želimo dobiti ID te komponente kot props
  props: ['id'],
  data() {
    return {
      selectedCoach: null,
    };
  },
  computed: {
    fullName() {
      return `${this.selectedCoach.firstName} ${this.selectedCoach.lastName}`;
    },
    contactLink() {
        return `${this.$route.path}/contact`
    },
  },
  // še preden je komponenta created fetchamo Coach Data za :id,
  created() {
    // funkcija find pričakuje funkcijo ki gre čez vse ID coachov iz coaches v vuex
    // in vrne true če je ta ID enak ID iz URL-a, ki smo ga dobili preko routerja kot props.
    this.selectedCoach = this.$store.getters['coaches/coaches'].find((coach) => coach.id === this.id);
  },
};
</script>
